import { render } from "./CraftMenu.vue?vue&type=template&id=0c7287c4&scoped=true&ts=true"
import script from "./CraftMenu.vue?vue&type=script&lang=ts"
export * from "./CraftMenu.vue?vue&type=script&lang=ts"

import "./CraftMenu.vue?vue&type=style&index=0&id=0c7287c4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7287c4"]])

export default __exports__